import React from 'react';

const inputStyle = (hasError) => ({
  width: '100%',
  background: 'transparent',
  border: 'none',
  borderBottom: hasError ? '2px solid #FF5722' : '2px solid rgba(156, 163, 175, 0.3)',
  borderRadius: 0,
  padding: '10px 0',
  fontFamily: 'var(--font-body)',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: 1.5,
  color: 'var(--color-foreground)',
  outline: 'none',
  transition: 'border-color 250ms ease-out',
  letterSpacing: '0.01em',
});

const labelStyle = {
  fontFamily: 'var(--font-caption)',
  fontSize: '11px',
  fontWeight: 500,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  color: 'var(--color-muted-foreground)',
  display: 'block',
  marginBottom: '8px',
};

const AddressSection = ({ formData, errors, onChange, onBlur }) => {
  const handleFocus = (e, hasError) => {
    if (!hasError) e.target.style.borderBottomColor = 'var(--color-primary)';
  };
  const handleBlur = (e, hasError) => {
    if (!hasError) e.target.style.borderBottomColor = 'rgba(156, 163, 175, 0.3)';
    onBlur?.(e);
  };

  const countries = [
    'Norge', 'Sverige', 'Danmark', 'Finland', 'Island',
    'Tyskland', 'Storbritannia', 'Frankrike', 'Nederland', 'Annet'
  ];

  return (
    <div>
      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '22px', fontWeight: 600, color: 'var(--color-foreground)', marginBottom: '24px', letterSpacing: '0.02em' }}>
        Adresseinformasjon
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="sm:col-span-2">
          <label style={labelStyle}>Gateadresse</label>
          <input
            name="streetAddress"
            type="text"
            value={formData?.streetAddress || ''}
            onChange={onChange}
            placeholder="Storgata 1"
            style={inputStyle(errors?.streetAddress)}
            onFocus={e => handleFocus(e, errors?.streetAddress)}
            onBlur={e => handleBlur(e, errors?.streetAddress)}
          />
          {errors?.streetAddress && <p style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', color: '#FF5722', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}><span>⚠</span>{errors?.streetAddress}</p>}
        </div>
        <div>
          <label style={labelStyle}>Postnummer</label>
          <input
            name="postalCode"
            type="text"
            value={formData?.postalCode || ''}
            onChange={onChange}
            placeholder="0001"
            style={inputStyle(errors?.postalCode)}
            onFocus={e => handleFocus(e, errors?.postalCode)}
            onBlur={e => handleBlur(e, errors?.postalCode)}
          />
          {errors?.postalCode && <p style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', color: '#FF5722', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}><span>⚠</span>{errors?.postalCode}</p>}
        </div>
        <div>
          <label style={labelStyle}>By</label>
          <input
            name="city"
            type="text"
            value={formData?.city || ''}
            onChange={onChange}
            placeholder="Oslo"
            style={inputStyle(errors?.city)}
            onFocus={e => handleFocus(e, errors?.city)}
            onBlur={e => handleBlur(e, errors?.city)}
          />
          {errors?.city && <p style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', color: '#FF5722', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}><span>⚠</span>{errors?.city}</p>}
        </div>
        <div className="sm:col-span-2">
          <label style={labelStyle}>Land</label>
          <select
            name="country"
            value={formData?.country || ''}
            onChange={onChange}
            style={{
              ...inputStyle(errors?.country),
              cursor: 'pointer',
              appearance: 'none',
              WebkitAppearance: 'none',
              paddingRight: '24px',
            }}
            onFocus={e => handleFocus(e, errors?.country)}
            onBlur={e => handleBlur(e, errors?.country)}
          >
            <option value="" style={{ background: '#1A1D20' }}>Velg land</option>
            {countries?.map(c => (
              <option key={c} value={c} style={{ background: '#1A1D20' }}>{c}</option>
            ))}
          </select>
          {errors?.country && <p style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', color: '#FF5722', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}><span>⚠</span>{errors?.country}</p>}
        </div>
      </div>
    </div>
  );
};

export default AddressSection;
